import api from './api'

const kkvBasePath = '/api/v1/kkv'

export async function getKkvCertificationResult(companyId) {
  const resp = await api.get(`${kkvBasePath}/${companyId}`, {
    timeout: 600000
  })
  return resp.data
}

export async function getDnbKkvCertificationResult(companyId) {
  const resp = await api.get(`${kkvBasePath}/dnb/${companyId}`, {
    timeout: 600000
  })
  return resp.data
}
